import * as React from 'react';
import {useFormikContext} from 'formik';
import {CourseObject} from 'api/course';
import Row from 'components/Row';
import Column from 'components/Column';
import Input from 'components/Input';
import FormContainer from '../../containers/FormContainer';

/**
 * The post access form part of settings
 * @return {React.ReactElement}
 * @constructor
 */
export default function PostAccessForm(): React.ReactElement {
  const formContext = useFormikContext<Partial<CourseObject>>();

  /**
   * Render content
   * @return {JSX.Element}
   */
  function renderContent(): JSX.Element {
    /**
     * Render days field
     * @return {JSX.Element}
     */
    function renderDays(): JSX.Element {
      /**
       * Handle input blur
       * @param {React.FocusEvent<HTMLInputElement>} event
       */
      function handleBlur(event: React.FocusEvent<HTMLInputElement>): void {
        formContext.setFieldValue('postAccess.days', event.target.value);
        formContext.submitForm();
      }

      return (
        <Column>
          <Row>
            <Column>
              <Input
                type="number"
                defaultValue={formContext.values.postAccess?.days}
                label="Доступ после прохождения (дни)"
                note="Доступ навсегда, если поле не заполнено"
                placeholder="Навсегда"
                onBlur={handleBlur}
              />
            </Column>
          </Row>
        </Column>
      );
    }

    return (
      <Row>
        {renderDays()}
      </Row>
    );
  }
  return (
    <FormContainer
      property="postAccess"
      label="Доступ к курсу после прохождения"
      collapse
    >
      {renderContent()}
    </FormContainer>
  );
}
